module.exports = __webpack_public_path__ + "media/images/athletes/16-3a524d3d15701f618b3998df71efb4eb.png";